// Google analytics
if (typeof window !== "undefined") {
  window.dataLayer = window.dataLayer || []
  // eslint-disable-next-line
  function gtag() {
    // eslint-disable-next-line
    dataLayer.push(arguments)
  }
  gtag("js", new Date())

  gtag("config", "UA-112059724-1")
}



// WEBPACK FOOTER //
// /opt/build/repo/src/config/analytics.js